/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { ExportIntegrationIndexQueryParams, ExportIntegrationIndexResponse } from '../types/ExportIntegrationIndex'

/**
 * GET /export-integrations
 * @see backend/nexus/modules/ExportIntegrations/Http/Controllers/ExportIntegrationController.php ExportIntegrationController::index
 */
export async function exportIntegrationIndex(
	params?: ExportIntegrationIndexQueryParams,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<ExportIntegrationIndexResponse>> {
	return axiosInstance.get('/export-integrations', { params, ...config })
}
